import axios, {AxiosInstance} from 'axios';
// import store from '@/store/index'

// const debug = process.env.NODE_ENV !== 'production'
// const baseURL = debug ? '/' : 'https://mp.api.mgtv.com/'

// const SUCCESS_CODE = [200, 0]
// 超时逻辑

const http: any = axios.defaults;

http.retry = 3;
http.retryDelay = 2000;

const instance = axios.create({
  timeout: 6000
});

//请求数据拦截器
instance.interceptors.request.use(request => {
  // Indicator.open();
  return request
}, err => {
  return Promise.reject(err);
});

instance.interceptors.response.use(
  response => {
    // Indicator.close();
    return response
  },
  err => {
    const config = err.config;
    // If config does not exist or the retry option is not set, reject
    if (!config || !config.retry) return Promise.reject(err);

    // Set the variable for keeping track of the retry count
    config.__retryCount = config.__retryCount || 0;

    // Check if we've maxed out the total number of retries
    if (config.__retryCount >= config.retry) {
      // Reject with the error
      return Promise.reject(err);
    }

    // Increase the retry count
    config.__retryCount += 1;

    // Create new promise to handle exponential backoff
    const backoff = new Promise(function(resolve) {
      setTimeout(function() {
        resolve();
      }, config.retryDelay || 1);
    });

    // Return the promise in which recalls axios to retry the request
    return backoff.then(function() {
      return axios(config);
    });
  }
);

export default instance;
